// extracted by mini-css-extract-plugin
export default {"construccionContainer":"Construccion_construccionContainer__AS-kb","cartelMedio":"Construccion_cartelMedio__6Hj3a","logo":"Construccion_logo__FI3vY"};